var $0e3cc9a288289dc5$exports = {};
$0e3cc9a288289dc5$exports = {
  "Empty": "\uBE44\uC5B4 \uC788\uC74C"
};
export { $0e3cc9a288289dc5$exports as default };